import { Participation } from '@app/api';
import { useParticipationTableContext } from './ParticipationTableContext';
import { useTranslation } from 'react-i18next';
import {
  Filter,
  formatTagFieldChoice,
  NULL_VALUE,
} from '../../components/Filter';
import { TextLoadingPlaceholder } from '@app/core';
import { TableColumnHeader } from './TableColumnHeader';
import { TableParticipationTagList } from '../../components/TableParticipationTagList';
import { ParticipantFieldType } from '@app/api';
import React from 'react';

export const TagsHeader = () => {
  const { t } = useTranslation();
  const { session, filtering } = useParticipationTableContext();

  if (!session?.availableTags || session.availableTags.length === 0) {
    return null;
  }

  return (
    <th key="tags">
      <TableColumnHeader>
        <span>{t('sessions.details.participantsDetails.columns.tags')}</span>
        <Filter
          fieldRef="tagsIds"
          fieldLabel={t('sessions.details.participantsDetails.columns.tags')}
          fieldType={ParticipantFieldType.TAGS}
          fieldValues={[
            ...(session.availableTags?.map(formatTagFieldChoice) ?? []),
            {
              label: t(
                'sessions.details.participationsDetails.tagFilter.noTag',
              ),
              value: NULL_VALUE,
            },
          ]}
          sessionId={session.id}
          currentFilterData={filtering.getFieldCurrentFilter('tagsIds')}
          onFilterDataChange={filtering.handleFilterChange}
        />
      </TableColumnHeader>
    </th>
  );
};

export const TagsCell = ({
  participation,
}: {
  participation: Participation;
}) => {
  const { session } = useParticipationTableContext();
  if (!session?.availableTags || session.availableTags.length === 0) {
    return null;
  }

  return (
    <td key="tags">
      <TableParticipationTagList
        participation={participation}
        session={session}
      />
    </td>
  );
};

export const TagsLoader = () => {
  const { t } = useTranslation();
  const { session } = useParticipationTableContext();
  if (!session?.availableTags || session.availableTags.length === 0) {
    return null;
  }
  return (
    <td key="tags">
      <TextLoadingPlaceholder
        sample={t('sessions.details.participantsDetails.columns.tags')}
      />
    </td>
  );
};
